import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import * as animationData from './../loaders/coop_caja_loader.json'
import PropTypes from 'prop-types';

const LottieLoader = props => {
    const { stop } = props
    useEffect(() => { window.addEventListener('resize', () => {/* console.log('cambio de screen') */ }); }) 
    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    return ( <Lottie options={defaultOptions}
      isStopped={stop}
      height={(window.innerWidth > 600) ? 400 : (window.innerWidth * 0.9 )}
      width={(window.innerWidth > 600) ? 400 : (window.innerWidth * 0.9)}/>
    );
    
};

LottieLoader.propTypes = {
    stop: PropTypes.bool.isRequired,
};

export default LottieLoader;